module.exports = __webpack_public_path__ + "static/media/copy-icon.72dd793a.svg";